import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaChevronDown,
} from "react-icons/fa";
import logo from "../Assets/logo.png";
import "./Header.css";
import { FaInstagram, FaXTwitter } from "react-icons/fa6";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(null);
  const location = useLocation();
  const headerRef = useRef(null); // ref for header

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const closeMenus = () => {
    setMenuOpen(false);
    setSubmenuOpen(null);
  };

  const toggleSubmenu = (menu) => {
    setSubmenuOpen((prev) => (prev === menu ? null : menu));
  };

  const isParentActive = (menu) => {
    if (menu === "destinations") {
      const destinations = [
        "USA",
                    "UK",
                    "Australia",
                    "Canada",
                    "NewZealand",
                    "Ireland",
                    "Germany",
                    "France",
                    "Europe",
                    "Dubai",
                    "Singapore",
                    "Switzerland",
                    "Afghanistan",
                    "Uzbekistan",
                    "Kazakhstan",
                    "Kyrgyzstan",
                    "Russia",
                    "Georgia",
                    "Poland",
                    "Italy",
                    "Netherlands",
                    "China",
                    "South Korea",
                    "Japan",
                    "Asia",
      ];
      return destinations.some(
        (country) => location.pathname === `/destinations/${country}`
      );
    } else if (menu === "services") {
      const services = [
        "career-councilling",
        "course-program-or-university-selection-advice",
        "admission-application-processing",
        "financial-aid-and-scholarship-applications",
        "pre-departure-orientation",
        "travel-and-forex-assistance",
        "post-departure-assistance",
      ];
      return services.some(
        (service) => location.pathname === `/services/${service}`
      );
    }
    return false;
  };

  // Close menus when route changes
  useEffect(() => {
    closeMenus();
  }, [location.pathname]);

  // Close submenu if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setSubmenuOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header ref={headerRef}>
      <div className="top-bar">
        <div className="container d-flex flex-wrap justify-content-between align-items-center py-1">
          <div className="d-flex gap-3 social-icons">
         <a href="https://www.instagram.com/novaedubridge/?hl=en" aria-label="Instagram"><FaInstagram /></a>
                       <a href="https://www.facebook.com/profile.php?id=61583095202515" aria-label="Facebook"><FaFacebookF /></a>
                       <a href="https://www.linkedin.com/company/109888916/admin/dashboard/" aria-label="Linked in"><FaLinkedinIn /></a>
                     <a href="https://x.com/NovaEdubridge" aria-label="Twitter"><FaXTwitter /></a>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-3 mt-1 mt-md-0 top-links">
            <span className="d-flex align-items-center">
              <FaPhoneAlt className="me-1 phone-icon" />
              Request Call Back:
              <strong className="ms-1">+91 99020 43004</strong>
            </span>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg bg-white py-3 main-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/" onClick={closeMenus}>
            <img src={logo} alt="Nova EduBridge" className="logo" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarNav"
            aria-expanded={menuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end onClick={closeMenus}>
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/courses"
                  onClick={closeMenus}
                >
                  Test Preparation
                </NavLink>
              </li>

              {/* Destinations */}
              <li className="nav-item dropdown">
                <button
                  type="button"
                  className={`nav-link dropdown-toggle ${
                    isParentActive("destinations") ? "active" : ""
                  }`}
                  onClick={() => toggleSubmenu("destinations")}
                >
                  Destinations <FaChevronDown className="ms-1" />
                </button>
                <ul className={`submenu ${submenuOpen === "destinations" ? "show" : ""}`}>
                  {[
                    "USA",
                    "UK",
                    "Australia",
                    "Canada",
                    "NewZealand",
                    "Ireland",
                    "Germany",
                    "France",
                    "Europe",
                    "Dubai",
                    "Singapore",
                    "Switzerland",
                    "Afghanistan",
                    "Uzbekistan",
                    "Kazakhstan",
                    "Kyrgyzstan",
                    "Russia",
                    "Georgia",
                    "Poland",
                    "Italy",
                    "Netherlands",
                    "China",
                    "South Korea",
                      "Japan",
                    "Asia",
                  ].map((country) => (
                    <li key={country}>
                      <NavLink
                        to={`/destinations/${country}`}
                        className="nav-link"
                        onClick={closeMenus}
                      >
                        {country}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>

              {/* Services */}
              <li className="nav-item dropdown">
                <button
                  type="button"
                  className={`nav-link dropdown-toggle ${
                    isParentActive("services") ? "active" : ""
                  }`}
                  onClick={() => toggleSubmenu("services")}
                >
                  Services <FaChevronDown className="ms-1" />
                </button>
                <ul
                  className="submenu"
                  style={{
                    display: submenuOpen === "services" ? "block" : "none",
                  }}
                >
                  {[
                    "university-country-course-selection",
                    "career-counselling-and-profile-evaluation",
                    "test-preparation",
                    "application-submission",
                    "visa-counseling",
                    "pre-departure-briefing",
                    "post-arrival-assistance-and-services",
                    "assistance-in-accommodation",
                    "education-loan-assistance",
                    "flight-ticket-booking-forex-and-insurance"
                  ].map((service) => (
                    <li key={service}>
                      <NavLink
                        to={`/services/${service}`}
                        className="nav-link"
                        onClick={closeMenus}
                      >
                        {service
                          .split("-")
                          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                          .join(" ")}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/about" onClick={closeMenus}>
                  About Us
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/careers"
                  onClick={closeMenus}
                >
                  Careers
                </NavLink>
              </li>
            </ul>

            <Link to="/Contact" className="cta-btn" onClick={closeMenus}>
              Contact Us
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
